import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../AuthContext";
import {useNotifications} from "../../components/NotificationSystem";
import {requestDMApproval} from "../../services/api/playersService";
import "../../styles/env.css";

const DMSignup: React.FC = () => {
  const {user} = useAuth();
  const navigate = useNavigate();
  const {addNotification} = useNotifications();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleRequestDMApproval = async () => {
    if (!user?.uid) {
      addNotification({
        type: "error",
        title: "Authentication Required",
        message: "You must be logged in to request DM status.",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      await requestDMApproval();

      addNotification({
        type: "success",
        title: "DM Request Submitted",
        message:
          "Your DM approval request has been submitted successfully. You'll receive an email notification once your account has been approved.",
      });

      // Navigate back to overview
      navigate("/overview");
    } catch (error: any) {
      const errorMessage =
        error.message ||
        "Failed to submit DM approval request. Please try again.";
      addNotification({
        type: "error",
        title: "Request Failed",
        message: errorMessage,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate("/overview");
  };

  return (
    <div className="env-page-container">
      <h2 className="env-page-title">Become a Dungeon Master</h2>

      <section className="env-section">
        <div className="env-card-large">
          <div className="env-card-title">DM Application</div>

          <div className="env-card-content">
            <p>
              Thank you for your interest in becoming a Dungeon Master for the
              League of Fabled Pursuits!
            </p>

            <div
              className="dm-notice"
              style={{marginTop: "1rem", marginBottom: "1rem"}}
            >
              <strong>Important:</strong> DM accounts require approval by an
              administrator before you can access DM features. This process
              typically takes less than a day, but please be patient if we're
              busy. You'll receive an email notification once your account has
              been approved.
            </div>

            <p>As a DM, you'll be able to:</p>
            <ul
              style={{
                marginLeft: "2rem",
                marginTop: "0.5rem",
                marginBottom: "1rem",
              }}
            >
              <li>Create and manage your own campaign settings (Titans)</li>
              <li>Schedule and run game sessions</li>
              <li>Manage player registrations for your sessions</li>
              <li>Log session events and award items to players</li>
              <li>Access DM-specific tools and features</li>
            </ul>

            <p>
              While your DM application is pending, you can continue to play as
              a regular player and participate in sessions run by other DMs.
            </p>
          </div>

          <div className="env-card-actions" style={{marginTop: "2rem"}}>
            <button
              className="btn btn-primary"
              onClick={handleRequestDMApproval}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting Request..." : "Submit DM Application"}
            </button>
            <button
              className="btn btn-secondary"
              onClick={handleCancel}
              disabled={isSubmitting}
            >
              Cancel
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DMSignup;
